import { render, staticRenderFns } from "./ClientPortal.vue?vue&type=template&id=2d3935e2&scoped=true&"
import script from "./ClientPortal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClientPortal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ClientPortal.vue?vue&type=style&index=0&id=2d3935e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3935e2",
  null
  
)

export default component.exports